<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card-title>
        <v-row>
          <v-col cols="12">
            <span class="text-h5">{{ titleCard }}</span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Hospital*" v-model="data.hospital" required :rules="[campoRequerido]" outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Ruc *" v-model="data.ruc" required :rules="[campoRequerido]" outlined
                dense></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Tipo institución*" v-model="data.tipo_institucion" required :rules="[campoRequerido]"
                outlined dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field label="Dirección*" v-model="data.direccion" required :rules="[campoRequerido]" outlined
                dense></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
                max-width="290px" min-width="auto">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="computedDateFormatted" label="Inicio de actividades" persistent-hint
                    prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" @change="loadFecha" :rules="[campoRequerido]"
                    outlined dense></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeEdit">
          Cancelar
        </v-btn>
        <v-btn color="blue darken-1" text @click="editItem" v-if="statusEdit">
          Guardar
        </v-btn>
        <v-btn color="blue darken-1" text @click="createItem" v-if="!statusEdit">
          Crear
        </v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="dialogLoader" hide-overlay persistent width="300">
      <v-card color="#1973a5" dark>
        <v-card-text>
          Cargando Datos
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<style>
.bg-primary-table {
  font-weight: 400;
}

.text-start {
  font-size: 0.8rem !important;
}

.container {
  max-width: 3000px !important;
}
</style>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {
  props: ['idItem'],
  data() {
    return {
      valid: true,
      dialogLoader: false,
      titleCard: "Nuevo hospital",
      data: {
        hospital: "",
        ruc: "",
        tipo_institucion: "",
        direccion: "",
        inicio_actividades: "",
        estado: null,
        idHospital: null
      },
      statusEdit: false,
      menu: false,
      date: new Date()
        .toISOString()
        .substr(0, 10),
      campoRequerido: (v) => !!v || "Campo Obligatorio.",
    };
  },
  methods: {
    loadFecha() {
      console.log("hola esta es la fecha de prueba", this.date);
    },
    closeEdit() {
      this.$emit("closeEdit");
    },
    editItem() {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          title: "¡Error!",
          text: "¡Debe completar los campos obligatorios!",
          icon: "error",
        });
        return;
      }
      this.data.inicio_actividades = this.date;
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .patch(RUTA_API + "/hospital/" + this.data.idHospital + "/", this.data, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se editó correctamente!",
                icon: "success",
              });
              this.closeEdit();
            })
            .catch((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo editar el formulario!",
                icon: "error",
                confirmButtonText: "Aceptar",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    createItem() {
      if (!this.$refs.form.validate()) {
        Swal.fire({
          title: "¡Error!",
          text: "¡Debe completar los campos obligatorios!",
          icon: "error",
        });
        return;
      }
      this.data.inicio_actividades = this.date;
      this.dialogLoader = true;
      axios
        .post(RUTA_API + "/api/token/", {
          username: USUARIO,
          password: PASSWORD,
        })
        .then((response) => {
          this.auth = "Bearer " + response.data.access;
          axios
            .post(RUTA_API + "/hospital/", this.data, {
              headers: { Authorization: this.auth },
            })
            .then((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Éxito!",
                text: "¡Se registró correctamente!",
                icon: "success",
                showCancelButton: true,
              });
              this.closeEdit();
            })
            .catch((res) => {
              this.dialogLoader = false;
              Swal.fire({
                title: "¡Error!",
                text: "¡No se pudo registrar el formulario!",
                icon: "error",
              });
            });
        })
        .catch((response) => {
          response === 404
            ? console.warn("lo sientimos no tenemos servicios")
            : console.warn("Error:", response);
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
  mounted() { },
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  created() {
    if (this.idItem.hospital) {
      this.statusEdit = true;
      this.data = this.idItem;
      this.date = this.idItem.inicio_actividades;
      /* this.DE = this.idItem; */
      this.titleCard = "Editar hospital"
      this.data.idHospital = this.idItem.id_Hospital;
      console.log("hola console log", this.idItem);
    } else {
      this.titleCard = "Crear hospital"
    }
  },
  components: {
  },
};
</script>